import adminAxiosInstance from "./api/adminAxiosInstance"; // <-- 1. IMPORTE A SUA INSTÂNCIA

// A rota base agora pega a baseURL da instância do Axios e adiciona o nosso path específico.
const BASE_ROUTE = `/communications`;

const messageService = {
  /**
   * Busca todas as mensagens.
   * Não precisa mais do 'token'.
   */
  getAllMessages: async () => {
    try {
      const response = await adminAxiosInstance.get(`${BASE_ROUTE}/messages`);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar mensagens:", error);
      throw error.response?.data || error;
    }
  },

  /**
   * Salva uma nova mensagem como rascunho.
   * Não precisa mais do 'token'.
   */
  saveDraft: async (messageData) => {
    try {
      const response = await adminAxiosInstance.post(
        `${BASE_ROUTE}/messages/draft`,
        messageData
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao salvar rascunho:", error);
      throw error.response?.data || error;
    }
  },

  /**
   * Atualiza um rascunho existente.
   * Não precisa mais do 'token'.
   */
  updateDraft: async (messageId, messageData) => {
    try {
      const response = await adminAxiosInstance.put(
        `${BASE_ROUTE}/messages/${messageId}/draft`,
        messageData
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao atualizar rascunho:", error);
      throw error.response?.data || error;
    }
  },

  /**
   * Envia ou agenda uma mensagem.
   * Não precisa mais do 'token'.
   */
  sendMessage: async (messageId, sendOptions) => {
    try {
      const response = await adminAxiosInstance.post(
        `${BASE_ROUTE}/messages/${messageId}/send`,
        sendOptions
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao enviar mensagem:", error);
      throw error.response?.data || error;
    }
  },

  /**
   * Deleta uma mensagem.
   * Não precisa mais do 'token'.
   */
  deleteMessage: async (messageId) => {
    try {
      const response = await adminAxiosInstance.delete(
        `${BASE_ROUTE}/messages/${messageId}`
      );
      return response.data;
    } catch (error) {
      console.error("Erro ao deletar mensagem:", error);
      throw error.response?.data || error;
    }
  },

};

export default messageService;
